export enum DESTINATION {
  EMAIL = 'email',
  SLACK = 'slack',
}
